(function () {
  const GIFT_VARIANT_ID = 54895243264213;
  const GIFT_QUANTITY = 2;

  // Monday, September 14, 2026 at 8:00 AM EDT
  const PROMO_START = new Date('2026-09-14T12:00:00Z');

  let isSyncingGift = false;
  let syncTimer = null;

  function promoIsActive() {
    return new Date() >= PROMO_START;
  }

  async function getCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to fetch cart');
    }

    return response.json();
  }

  async function addGift() {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: GIFT_QUANTITY,
            properties: {
              _subscription_gift: 'true'
            }
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error('Unable to add subscription gift');
    }
  }

  async function changeGift(giftKey, quantity) {
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: giftKey,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error('Unable to update subscription gift');
    }
  }

  async function syncSubscriptionGift() {
    if (isSyncingGift) return;

    isSyncingGift = true;

    try {
      const cart = await getCart();

      const giftLines = cart.items.filter(item => {
        return item.variant_id === GIFT_VARIANT_ID;
      });

      // Before promo start, make sure no gift is present.
      if (!promoIsActive()) {
        if (giftLines.length) {
          for (const giftLine of giftLines) {
            await changeGift(giftLine.key, 0);
          }
        }
        return;
      }

      const hasSubscription = cart.items.some(item => {
        return (
          item.variant_id !== GIFT_VARIANT_ID &&
          item.selling_plan_allocation
        );
      });

      const gift = giftLines[0];

      if (hasSubscription) {
        if (!gift) {
          await addGift();
        } else if (gift.quantity !== GIFT_QUANTITY) {
          await changeGift(gift.key, GIFT_QUANTITY);
        }

        if (giftLines.length > 1) {
          for (const duplicateGift of giftLines.slice(1)) {
            await changeGift(duplicateGift.key, 0);
          }
        }
      }

      if (!hasSubscription && giftLines.length) {
        for (const giftLine of giftLines) {
          await changeGift(giftLine.key, 0);
        }
      }
    } catch (error) {
      console.error('Subscription gift:', error);
    } finally {
      isSyncingGift = false;
    }
  }

  function scheduleGiftSync() {
    clearTimeout(syncTimer);

    syncTimer = setTimeout(() => {
      syncSubscriptionGift();
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleGiftSync);
  } else {
    scheduleGiftSync();
  }

  const observer = new MutationObserver(() => {
    if (!isSyncingGift) {
      scheduleGiftSync();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();